import dayjs from 'dayjs';

export const formatLeadListTime = (isoDate: string | null): string => {
  if (!isoDate) return '';

  const target = dayjs(isoDate);

  if (!target.isValid()) return '';

  const now = dayjs();

  if (target.isSame(now, 'day')) {
    return target.format('HH:mm');
  }

  if (target.isSame(now.subtract(1, 'day'), 'day')) {
    return 'Вчера';
  }

  if (target.isSame(now, 'year')) {
    return target.format('D MMM');
  }

  return target.format('DD.MM.YYYY');
};
